import React from 'react';

function Footer() {
  return (
    <footer className="text-slate-100 sticky bg-zinc-800 h-20 p-4 text-center text-sm lg:text-base">
      <p>
        Built with <span className="text-lightGreen">React.js</span> and <span className="text-lightGreen">TailwindCSS</span>
      </p>
      <p>&#169; 2022 Joao Marco Matta</p>
    </footer>
  );
}

export default Footer;
